export const MINIMUM_VOUCHER_LOAN_AMOUNT = 20000
export const HIGH_VOUCHER_LOAN_AMOUNT = 50000
export const STANDARD_VOUCHER_AMOUNT = 100
export const HIGH_VOUCHER_AMOUNT = 150

const isValidLoanAmount = (amount: unknown): amount is number =>
  typeof amount === 'number' && Number.isFinite(amount)

export const resolveTieredVoucherAmount = (
  loanAmount: unknown
): number | null => {
  if (!isValidLoanAmount(loanAmount)) return null
  if (loanAmount >= HIGH_VOUCHER_LOAN_AMOUNT) return HIGH_VOUCHER_AMOUNT
  if (loanAmount >= MINIMUM_VOUCHER_LOAN_AMOUNT) {
    return STANDARD_VOUCHER_AMOUNT
  }
  return null
}

export const resolveLegacySmavaVoucherAmount = (
  loanAmount: unknown
): number | null => {
  if (!isValidLoanAmount(loanAmount)) return null
  if (loanAmount >= HIGH_VOUCHER_LOAN_AMOUNT) return HIGH_VOUCHER_AMOUNT
  if (loanAmount > MINIMUM_VOUCHER_LOAN_AMOUNT && loanAmount !== 30000) {
    return STANDARD_VOUCHER_AMOUNT
  }
  return null
}
